export async function compressImage(
  file,
  { maxSide = 1600, mimeType = "image/webp", quality = 0.82 } = {}
) {
  const img = await loadImage(file);
  const { canvas, ctx, width, height } = makeCanvas(img, maxSide);

  ctx.drawImage(img, 0, 0, width, height);

  const blob = await canvasToBlob(canvas, mimeType, quality);
  return new File([blob], replaceExt(file.name, extFromMime(mimeType)), {
    type: mimeType,
  });
}

export async function makeThumbnail(
  file,
  { maxSide = 400, mimeType = "image/webp", quality = 0.8 } = {}
) {
  const img = await loadImage(file);
  const { canvas, ctx, width, height } = makeCanvas(img, maxSide);

  ctx.drawImage(img, 0, 0, width, height);

  const blob = await canvasToBlob(canvas, mimeType, quality);
  return new File(
    [blob],
    addSuffix(replaceExt(file.name, extFromMime(mimeType)), "_thumb"),
    { type: mimeType }
  );
}


function loadImage(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

function makeCanvas(img, maxSide) {
  const ratio = img.width / img.height;
  let width, height;

  if (img.width >= img.height) {
    width = Math.min(img.width, maxSide);
    height = Math.round(width / ratio);
  } else {
    height = Math.min(img.height, maxSide);
    width = Math.round(height * ratio);
  }

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext("2d", { alpha: false });
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";

  return { canvas, ctx, width, height };
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), type, quality);
  });
}

function replaceExt(name, newExt) {
  return name.replace(/\.[^.]+$/, "") + newExt;
}

function addSuffix(name, suffix) {
  return name.replace(/\.[^.]+$/, "") + suffix + name.match(/\.[^.]+$/)?.[0] ?? "";
}

function extFromMime(mime) {
  if (mime === "image/webp") return ".webp";
  if (mime === "image/avif") return ".avif";
  return ".jpg";
}
